export function mergeVariantQuantities(...groups) {
  const totals = new Map();
  for (const value of groups.flat()) {
    const name = String(value?.name || "").trim();
    const qty = Number(value?.qty);
    if (name && Number.isFinite(qty) && qty > 0) totals.set(name, (totals.get(name) || 0) + qty);
  }
  return Array.from(totals, ([name, qty]) => ({ name, qty }));
}

export const variantTotal = (values) => values.reduce((sum, value) => sum + Number(value.qty || 0), 0);

export function itemVariantQuantities(item) {
  const values = mergeVariantQuantities(item.variant_quantities || []);
  // Held carts created before multi-variant selection keep their original label.
  return values.length ? values : item.variant ? mergeVariantQuantities([{ name: item.variant, qty: item.qty }]) : [];
}

export function variantSummary(item, separator = " • ") {
  const values = itemVariantQuantities(item);
  const summary = values.map(({ name, qty }) => `${name} ${qty}`).join(separator);
  // A revised receipt after a partial refund has no per-variant refund allocation.
  return summary && Math.abs(variantTotal(values) - Number(item.qty)) > 0.000001 ? `Varian awal: ${summary}` : summary;
}

export function changeVariantQuantity(item, name, delta) {
  const variants = itemVariantQuantities(item).map((value) => value.name === name ? { ...value, qty: Math.max(0, value.qty + delta) } : value).filter((value) => value.qty > 0);
  return { ...item, variant: null, variant_quantities: variants, qty: variantTotal(variants) };
}

export function appendCartItem(cart, incoming) {
  const variants = itemVariantQuantities(incoming);
  const index = cart.findIndex((item) => item.product_id === incoming.product_id
    && (item.unit?.name || null) === (incoming.unit?.name || null)
    && (item.manualPrice ?? null) === (incoming.manualPrice ?? null)
    && (item.note || "") === (incoming.note || "")
    && !!itemVariantQuantities(item).length === !!variants.length);
  if (index < 0) return [...cart, { ...incoming, variant: null, variant_quantities: variants }];
  return cart.map((item, i) => i !== index ? item : {
    ...item, qty: item.qty + incoming.qty,
    discount: Number(item.discount || 0) + Number(incoming.discount || 0),
    variant: null, variant_quantities: mergeVariantQuantities(itemVariantQuantities(item), variants),
  });
}
